;(function () {
  const getCurrency = () => {
    const currencyElement = document.querySelector("meta[property='currency']")
    if (currencyElement) {
      return JSON.parse(currencyElement.getAttribute("content"))
    }
    return null
  }

  const state = {
    currency: getCurrency,
  }

  window.HB = window.HB || {}
  window.HB.state = state
})()
